module.exports = __webpack_public_path__ + "img/edit.7387a8d6.svg";